/**
 * @file topic-content-mutations
 */

import officialProcessMutations from './officialProcess';
import replyMutations from './reply';

export default {
    initTopicData(state, data) {
        state.topicData = data;
        // 防止取不着replyIds报错
        if (!data.ext || !data.ext.replyTopInfo) {
            return;
        }
        state.questionFeedbackId = data.ext.replyTopInfo.replyIds.questionFeedback;
        state.fixedFeedbackId = data.ext.replyTopInfo.replyIds.fixedFeedback;
    },
    clearTopicContentData(state) {
        state.topicData = {};
        state.replyData = {};
        state.relatedLinkList = [];
    },
    changeConfirmState(state, confirmName) {
        state[confirmName] = !state[confirmName];
    },
    setContentType(state, isIssueType) {
        state.isIssueType = isIssueType;
    },
    setRelatedLinkList(state, list) {
        state.relatedLinkList = list;
    },
    setIssueHeaderHeight(state, height) {
        state.issueHeaderHeight = height;
    },
    toggleReplyShow(state, val) {
        state.isReplyShow = val;
    },
    ...officialProcessMutations,
    ...replyMutations
};
